import React, { useState, useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { useHistory, useLocation } from 'react-router-dom';
import loadable from '@loadable/component';
import SignupModal from '../../components/SignupModal/SignupModal';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { camelize } from '../../util/string';
import { propTypes } from '../../util/types';

import FallbackPage from './FallbackPage';
import { ASSET_NAME, fetchUserBookingStatus } from './LandingPage.duck';
import { Helmet } from 'react-helmet-async';

import { fetchFeaturedListings } from '../../ducks/featuredListings.duck';
import { getListingsById } from '../../ducks/marketplaceData.duck';
import { getFeaturedListingsProps } from '../../util/data';
import WelcomeModal from '../../components/WelcomeModal/WelcomeModal';
import { MandatoryNotificationModal } from '../../components';
import useMedian from '../../hooks/useMedian';
import { fetchSheetData } from '../../util/api';
import { promptUserLocation } from '../../util/locationPrompt';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

export const LandingPageComponent = props => {
  console.log('[LandingPage] render', typeof window === 'undefined' ? 'SERVER' : 'CLIENT');
  const { isMedian } = useMedian();

  const { pageAssetsData, inProgress, error, currentUser, onFetchUserBookingStatus } = props;
  const [showModal, setShowModal] = useState(false);
  const [hasCompletedBooking, setHasCompletedBooking] = useState(false);
  const [bookingStatusChecked, setBookingStatusChecked] = useState(false);
  const [wasLoggedIn, setWasLoggedIn] = useState(false);
  const location = useLocation();
  const history = useHistory();
  const isNewUser = () => {
    if (!currentUser?.attributes?.createdAt) return false;

    const createdAt = new Date(currentUser.attributes.createdAt);
    const now = new Date();

    const diffInSeconds = (now - createdAt) / 1000;

    return diffInSeconds < 15;
  };

  const userLoggedIn = !!(
    currentUser &&
    currentUser.id &&
    currentUser.attributes?.state === 'active'
  );

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // You can pass search, category, sortBy, and order parameters here
    fetchSheetData()
      .then((result) => {
        if (result.success) {
          setData(result.data);
        } else {
          // setError(result.error);
        }
      })
      .catch((err) => {
        console.error(err);
        // setError(err.message);
      })
      .finally(() => {
        setLoading(false);
      });

    if (typeof window !== 'undefined') {
      promptUserLocation();
    }
  }, []);
  // if (loading) return <div>Loading data...</div>;
  // if (error) return <div>Error loading data: {error}</div>;


  useEffect(() => {
    const isCustomer = currentUser?.attributes?.profile?.publicData?.userType === 'customer';

    if (!userLoggedIn || !isCustomer) {
      setBookingStatusChecked(true);
      return;
    }

    onFetchUserBookingStatus().then(result => {
      setHasCompletedBooking(result);
      setBookingStatusChecked(true);
    });
  }, [currentUser]);
  const showWelcome = userLoggedIn && isNewUser();

  useEffect(() => {
    if (showWelcome && !isMedian) {
      setShowModal(true);
    }
  }, [currentUser, isMedian]);
  useEffect(() => {
    if (userLoggedIn) {
      setWasLoggedIn(true);
    }
  }, [userLoggedIn]);

  useEffect(() => {
    if (!bookingStatusChecked || (isMedian && userLoggedIn)) return;

    const isProvider = currentUser?.attributes?.profile?.publicData?.userType === 'provider';

    const guestModalShown = sessionStorage.getItem('guestSignupModalShown');

    const postLoginModalShown = sessionStorage.getItem('postLoginModalShown');

    const shouldShowGuestModal = !userLoggedIn && !wasLoggedIn && !guestModalShown;

    const shouldShowPostLoginModal =
      userLoggedIn && !hasCompletedBooking && !postLoginModalShown && !isProvider;

    if (!shouldShowGuestModal && !shouldShowPostLoginModal) {
      return;
    }

    const timer = setTimeout(() => {
      setShowModal(true);

      if (userLoggedIn) {
        sessionStorage.setItem('postLoginModalShown', 'true');
      } else {
        sessionStorage.setItem('guestSignupModalShown', 'true');
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, [bookingStatusChecked, hasCompletedBooking, currentUser, showWelcome, userLoggedIn]);

  useEffect(() => {
    if (location.state?.showProviderError) {
      toast.error(
        <div>
          You must become a provider to list your services.
          <br />
          Contact{' '}
          <a
            href="mailto:support@purfurry.com?subject=Request%20to%20Become%20a%20Provider&body=Hi%20Purfurry%20Team,%0D%0A%0D%0AI%20would%20like%20to%20list%20my%20service.
          %20Please%20help%20me%20with%20the%20signup%20process%20and%20new%20listing%20creation.%0D%0A%0D%0AThank%20you!"
          >
            support@purfurry.com
          </a>{' '}
          to request access.
        </div>,
        { autoClose: 7000 }
      );

      history.replace({
        ...location,
        state: { ...location.state, showProviderError: false },
      });
    }

    if (location.state?.showCustomerAlreadyLoggedInError) {
      toast.error(
        <div>
          You are logged in as a customer.
          <br />
          If you want to become a provider, contact{' '}
          <a href="mailto:support@purfurry.com?subject=Request%20to%20Become%20a%20Provider&body=Hi%20Purfurry%20Team,%0D%0A%0D%0AI%20would%20like%20to%20become%20a%20provider.%20Could%20you%20please%20share%20more%20details%20about%20the%20signup%20process%20and%20any%20requirements%20I%20should%20know%20about?%0D%0A%0D%0AHere%20are%20my%20contact%20details:%0D%0AAddress:%20%5BYour%20Address%5D%0D%0APhone:%20%5BYour%20Phone%20Number%5D%0D%0A%0D%0AThank%20you!">
            support@purfurry.com
          </a>
          .
        </div>,
        { autoClose: 7000 }
      );

      history.replace({
        ...location,
        state: { ...location.state, showCustomerAlreadyLoggedInError: false },
      });
    }
    if (location.state?.showProviderAlreadyLoggedInError) {
      toast.error('You are already logged in as a provider.', { autoClose: 5000 });

      history.replace({
        ...location,
        state: { ...location.state, showProviderAlreadyLoggedInError: false },
      });
    }
  }, [location.state]);
  useEffect(() => {
    const isProvider = currentUser?.attributes?.profile?.publicData?.userType === 'provider';

    if (userLoggedIn && isProvider && location.pathname === '/') {
      history.replace('/listings');
    }
  }, [userLoggedIn, currentUser, location.pathname, history]);
  return (
    <div id="landing-page-root">
      <Helmet>
        <title> | Purfurry</title>
        <meta name="description" content="" />
        <meta
          name="keywords"
          content="Purfurry, boarding near me dogs, dog boarding, boarding for dogs, pet boarding, dog hostel near me, pet boarding services, boarding near me dogs, pet grooming, pet daycare"
        />
      </Helmet>
      <PageBuilder
        pageAssetsData={pageAssetsData?.[camelize(ASSET_NAME)]?.data}
        inProgress={inProgress}
        error={error}
        fallbackPage={<FallbackPage error={error} />}
        featuredListings={getFeaturedListingsProps(camelize(ASSET_NAME), props)}
      />

      {/* {showModal && <SignupModal onClose={() => setShowModal(false)} userLoggedIn={userLoggedIn} />} */}
      {showModal && (!isMedian || !userLoggedIn) &&
        (showWelcome ? (
          <WelcomeModal
            userName={currentUser?.attributes?.profile?.displayName}
            onClose={() => setShowModal(false)}
          />
        ) : (
          <SignupModal onClose={() => setShowModal(false)} userLoggedIn={userLoggedIn} />
        ))}
      <MandatoryNotificationModal isMedian={isMedian} currentUser={currentUser} />
      <ToastContainer
        position="top-center"
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

LandingPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
  currentUser: propTypes.currentUser,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  const { currentUser } = state.user || {};
  const featuredListingData = state.featuredListings || {};

  const getListingEntitiesById = listingIds => getListingsById(state, listingIds);

  return {
    pageAssetsData,
    featuredListingData,
    getListingEntitiesById,
    inProgress,
    error,
    currentUser,
  };
};

const mapDispatchToProps = dispatch => ({
  onFetchFeaturedListings: (sectionId, parentPage, listingImageConfig, allSections) =>
    dispatch(fetchFeaturedListings({ sectionId, parentPage, listingImageConfig, allSections })),
  onFetchUserBookingStatus: () => dispatch(fetchUserBookingStatus()),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const LandingPage = compose(connect(mapStateToProps, mapDispatchToProps))(LandingPageComponent);

export default LandingPage;
